import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card my-3" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "card-px text-center py-20 my-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bolder mb-10" }, "Authentication Required", -1)
const _hoisted_5 = { class: "text-gray-400 fs-4 fw-bold mb-10" }
const _hoisted_6 = ["data-kt-indicator"]
const _hoisted_7 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_8 = { class: "indicator-progress" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.error_message), 1),
        _createElementVNode("button", {
          "data-kt-indicator": _ctx.loading ? 'on' : null,
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.authenticateAndPay && _ctx.authenticateAndPay(...args)))
        }, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Authenticate"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_6)
      ])
    ])
  ]))
}